import React from 'react';
import {Link} from 'react-router-dom';
import {Image,Card,Media,Button,Badge} from 'react-bootstrap';
import Icofont from 'react-icofont';
import PropTypes from 'prop-types'; 

class CoupenCard extends React.Component {
  
	render() {
    	return (
    		<Card className="bg-white payments-item mb-4 shadow-sm">
            	<div className="gold-members p-4">
              <span className="float-right"> 
   
  
   <Button variant='outline-secondary' onClick={() => this.props.showUpdateCoupenModel(this.props.coupenObj)} size="sm" title="edit"><Icofont icon='pencil-alt-1'/></Button>

     
     <Button variant='outline-secondary' onClick={this.props.onClick}  size="sm" className="ml-2" title="delete"><Icofont icon='trash'/></Button>
     
   </span>
                  <Media>
                     <Media.Body>
                        <h4 className="mb-1">Title : {this.props.title}</h4>
	                      {this.props.subTitle?
			                	<p>
			                	<h6>Coupon Code: {this.props.subTitle}</h6>	
			                	</p>
                        
			                	:""
			              }	<p>
							  <h6>
    Starts From <Badge variant="secondary">{this.props.coupenObj.start_date}</Badge>
  </h6>

  <h6>

    Ends At <Badge variant="secondary">{this.props.coupenObj.end_date}</Badge>
  </h6>		 
  
  <h6>
    Discount in {(this.props.coupenObj["enable_percentage"]==true)?"%":"$"}:
	<Badge  variant="danger">
    {this.props.coupenObj.coupen_discount}
	{" "}
	{(this.props.coupenObj["enable_percentage"]==true)?"%":""}
  </Badge>{' '}

  </h6>	
  			  <table>
								  <tr>
									  <td>  <b>Applicable for the above:</b></td>
									  <td>{this.props.coupenObj.enble_order_limit}</td>
								  </tr>
								  <tr>
									  <td>Total Coupons Applied :</td>
									  <td>{this.props.coupenObj.applied_orders.length}</td>

								  </tr>
								  </table>
                  
                  </p>
                       
                    </Media.Body>
           		  </Media>
           		</div>
            </Card>
    	);
    }
}

CoupenCard.propTypes = {
  title: PropTypes.string.isRequired,
  logoImage: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  imageAlt: PropTypes.string,
  imageclassName: PropTypes.string,
  onClick: PropTypes.func.isRequired
};
CoupenCard.defaultProps = {
  subTitle: '',
  imageAlt: '',
  imageclassName: '',
}

export default CoupenCard;